import React, {Component} from 'react';
import {connect} from 'react-redux';
import {verifyResetLink} from '../../../actions/login';
import NewPasswordForm from '../new-password';

import {LINK} from '../../../data/resetTypes';

class PasswordResetReceiver extends Component {
  componentWillMount() {
    console.log('PasswordResetReceiver');
    if (this.props.valid === null) {
      const {id} = this.props.match.params;
      verifyResetLink({reset_password_token: id});
    }
  }

  render() {
    const {valid} = this.props;
    console.log('render', valid);
    return (
      <div>
        { valid && <NewPasswordForm resetType={LINK}/> }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  valid: state.verifyResetLink.linkValid,
  errors: state.verifyResetLink.errors
});

export default connect(mapStateToProps)(PasswordResetReceiver);




// WEBPACK FOOTER //
// ./src/components/auth/password-reset-receiver/index.jsx